const Icon = ({ icon, iconType, className, ...rest }) => {
    return iconType === 'fontawesome' ? (
        <i className={`${className} ${icon}`} {...rest} />
    ) : (
        <img alt={icon} src={icon} className={className} {...rest} />
    );
};

export default Icon;
